import { useEffect, useState } from 'react'
import { api, type Category } from '../lib/api'
import { CategoryGrid } from '../components/ProductGrid'

export function CatalogListPage() {
  const [items, setItems] = useState<Category[]>([])
  const [q, setQ] = useState('')
  useEffect(() => {
    const qs = q ? `q=${encodeURIComponent(q)}&limit=100` : 'limit=100'
    api.categories(qs).then((r) => setItems(r.categories))
  }, [q])
  return (
    <>
      <h1 className="page-title">Danh sách sản phẩm</h1>
      <div className="toolbar">
        <input placeholder="Tìm…" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      <CategoryGrid items={items} />
    </>
  )
}
